import _ from "underscore";

export default {
  get: function () {
    // Get account
    const account = JSON.parse(localStorage.getItem("rj-account"));

    // If account is object, return account; else, return empty object
    return _.isObject(account) ? account : {};
  },
  set: function (data) {
    localStorage.setItem("rj-account", JSON.stringify(data));
  },
  save: function (data) {
    // Get account
    const account = this.get();

    // Apply data to account and set
    this.set(_.extend(account, data));
  },
  isPropertyInSentList: function (building_id, unit_id) {
    // Get account
    const account = this.get();

    // If account has sent list
    if (account.sent) {
      // Check if inquiry already sent for property ID
      return account.sent.indexOf(`${building_id},${unit_id || ""}`) !== -1;
    } else {
      return false;
    }
  },
  addPropertyToSentList: function (building_id, unit_id) {
    // Get account
    const account = this.get();

    // Ensure sent list is initialized
    if (!account.sent) {
      account.sent = [];
    }

    // Add property ID
    account.sent.push(`${building_id},${unit_id || ""}`);

    // Set account
    this.set(account);
  },
};
